const SVG = ({ fill = 'none', width = '24', height = '24', viewBox = '0 0 24 24' }) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 6.146C1 4.961 1.961 4 3.146 4h17.708C22.039 4 23 4.961 23 6.146v11.805a2.146 2.146 0 01-2.146 2.147H3.146A2.146 2.146 0 011 17.95V6.146z"
      stroke="#192043"
      strokeWidth="1.25"
    />
    <path
      d="M3.504 17.772l5.83-5.645m5.332 0l5.83 5.645M20.496 6.325l-8.372 8.107a.179.179 0 01-.248 0L3.504 6.325"
      stroke="#4E546C"
      strokeWidth="1.25"
      strokeLinecap="round"
    />
  </svg>
)

export default SVG
